import * as React from 'react';
import logo from '../img/home.png'
import Cart from './Cart';
import RenderPage from './RenderPage';
import BottomBar from './BottomBar'
import menu from './jsonMenu/menu.json';


class NewPranzoCena extends React.Component {

  constructor(props) {
    super(props);
    this.cart = props.cart
    this.state = {
      openCart: false,
      cart: props.cart
    };
  }

  setOpenCart = (isOpen) => {
    this.setState({
      openCart: isOpen,
      cart: this.cart
    });
  }

  setCart = (cart) => {
    this.setState({
      cart: cart
    });
  }

  render() {
    return (
      <React.Fragment key={3}>
        <div className="Content">
          <img src={logo} alt="home" className="newMenu" />
          {/* {this.renderMenu(this.state.menujson)} */}
          <RenderPage
            menujson={menu}
            setCart={this.setCart}
            cart={this.cart}
          />
          {this.state.openCart ? 
          <Cart
            isOpenCart={this.state.openCart}
            setOpenCart={this.setOpenCart}
            cart={this.state.cart}
          />: ""}
          <BottomBar setOpenCart={this.setOpenCart} setIsOpenInfo={this.props.setIsOpenInfo}/>
        </div>
      </React.Fragment>
    );
  }
}
export default NewPranzoCena